<template>
  <div>
    <span>{{ value.street }}</span><br />
    <span v-if="value.street2">{{ value.street2 }}</span><br v-if="value.street2" />
    <span>{{ value.city }}, {{ value.state }} {{ value.zipcode }} {{ value.country }}</span>
  </div>
</template>
<script>
export default {
  name: 'AddressText',
  props: [ 'value' ]
}
</script>
